<template>
  <div>
   
    <van-tabs v-model="activeName" swipeable>

      <van-tab style="margin-top:15px; padding-left:15px" title="Genel" name="0">
       
        <van-field v-model="no" label="No : " disabled />
        <van-field v-model="st" label="Tipi :" disabled />
        <van-field v-model="sd" label="Durumu :" disabled>
          <template #button>
            <van-button @click="baslat" v-if="sdid===2" size="small" type="danger">
              <div v-if="btspinner===false">Başlat</div>
              <van-loading v-if="btspinner===true" type="spinner" size="24px" color="#fff"/>
            </van-button>
            <van-button :to="`/tamamla/${id*8589}`" v-if="sdid===3" size="small" type="warning">Tamamla</van-button>
          </template>
        </van-field>
        

        <van-field v-model="sn" disabled label="Şikayet :" />
        <van-field v-model="so" type="text"  disabled  label="Öncelik :" />
        
<!--
        <van-field label="Paylaşım :" >
          <template #button><van-button size="small" type="primary">Paylaş</van-button></template>
        </van-field>

        <van-field label="Servis Kilit :" >
          <template #button><van-button size="small" type="primary">Kilitle</van-button></template>
        </van-field>
-->
       </van-tab>
  
        <van-tab style="margin-top:15px; padding-left:15px" title="Cihaz" name="1">
          <van-field v-model="barkod" disabled label="Barkod : " />
          <van-field v-model="serino" disabled label="SeriNo : " />
          <van-field clickable v-model="alias" label="Model" @click="show = true"/>   <!--disabled -->
          <van-field v-model="lokasyon" rows="2" autosize label="İç Lokasyon" type="textarea" maxlength="100"/>
          <van-button @click="lokasyonUpdate()"  style="margin-top:10px;" size="large" type="default">BİLGİLERİ GÜNCELLE</van-button>
        </van-tab>

        <van-tab style="margin-top:15px; padding-left:15px" title="Müşteri" name="2">
          <van-field v-model="cari" label="Müşteri : " disabled />
          <!-- <van-field v-model="tel" label="Tel :" disabled /> -->
          <van-field v-model="gsm" label="Gsm :" />
          <van-field v-model="mail" label="E-posta :" />


           <van-field v-model="enlem" label="Enlem :" disabled />
          <van-field v-model="boylam" label="Boylam :" disabled />
          <van-field v-model="adres" rows="5" autosize type="textarea" label="Adres :" disabled />
          <!-- <van-button v-if="sdid===3" :to="`/konum/${id}`" style="margin-top:10px" size="large" type="default">KONUMA GİT</van-button> -->
          <van-button @click="cariUpdate()"  style="margin-top:10px;" size="large" type="default">BİLGİLERİ GÜNCELLE</van-button>

        </van-tab>
        <van-tab style="margin-top:15px; padding-left:15px" title="Not" name="3">
          <van-field v-model="snot" style="font-size: 16px;"  disabled rows="12" autosize label="Servis Notu :" type="textarea" maxlength="1500"/>

        </van-tab>
    </van-tabs>

    
<div style="height:70px"></div>
        <van-tabbar v-model="active">
          <van-tabbar-item name="servis" to="/servis" icon="wap-home-o">Servis</van-tabbar-item>   
          <van-tabbar-item name="detay" :to="`/servis/${id*8589}`" icon="home-o">Genel</van-tabbar-item>

          <van-tabbar-item v-if="btspinner===true">
            <van-loading type="spinner" size="24px" color="#ff7f00"/>
          </van-tabbar-item>
          <van-tabbar-item v-if="btspinner===true">
            <van-loading type="spinner" size="24px" color="#ff7f00"/>
          </van-tabbar-item>
          <van-tabbar-item v-if="btspinner===true">
            <van-loading type="spinner" size="24px" color="#ff7f00"/>
          </van-tabbar-item>
          <van-tabbar-item v-if="btspinner===true">
            <van-loading type="spinner" size="24px" color="#ff7f00"/>
          </van-tabbar-item>


          <van-tabbar-item v-if="sdid===3"  name="islem" :to="`/islem/${id*8589}`" icon="notes-o">İşlem</van-tabbar-item>      
          <van-tabbar-item v-if="sdid===3" name="stok" :to="`/stok/${id*8589}`" icon="points">Stok</van-tabbar-item> 
          <van-tabbar-item v-if="sdid===3" name="matbuu" :to="`/matbuu/${id*8589}`" icon="photo-o">Matbuu</van-tabbar-item>
          <van-tabbar-item name="cihaz" :to="`/cihaz/${id*8589}`" icon="eye-o">Extra</van-tabbar-item>
        </van-tabbar>


        <van-popup v-model="show" closeable  position="bottom" round :style="{ height: '80%', margin: '10px auto auto auto', padding: '5px'}">
          <van-divider>Cihaz Listesi</van-divider>

            <van-cell @click="changeCihaz(post)"
           v-for="(post,index) in listCihaz" :key="index" center :title="'B: '+post.barkod" :value="post.cihazgrup+' '+post.cihazaltgrup" :label="'S: '+post.chz_serino" />
        </van-popup>     


  </div>
</template>

<script>
import { Toast } from 'vant';
import { Dialog } from 'vant';

export default {
  data() {
    return {
      show:true,
      //changeCihaz:'',
      sid:'',
      listCihaz:[],
      id:this.$route.params.id / 8589,
      loading:false,
      finished:false,
      list:[],
      error:[],
      donem: this.$request.donem(),
      active:'detay',
      activeName: 0,
      sdid:'',
      no:'',
      st:'',
      sd:'',
      sn:'',
      so:'',
      snot:'',
      barkod:'',
      serino:'',
      alias:'',
      model:'Cihaz Seçiniz',
      lokasyon:'',
      cari:'',
      gsm:'',
      mail:'',
      adres:'',
      enlem:'',
      boylam:'',
      ayar:this.$request.ayar(),
      btspinner : false,
      cid:'',
      show:false,
      grup : [],
      anagrupicker:false,
      altgrup : [],
      altgrupicker:false,
      katid:0
    };
  },
  created(){
  this.yetki();
  },
  methods: {
          yetki:function(){
          let baslat = false;
          let table ='';
            if (this.ayar.ya==='sid'){
                this.table = 'servis'
                baslat = true
                this.getPostsAsync(table,baslat)
            }
            else{
              this.table = 'kayit'
              baslat=true
              this.getPostsAsync(table,baslat)
            }
          },
          getcihaz(adresguid,cihazid){ //cari cihaz listesi
            var data = "'" + adresguid + "'"
            this.$request.post("servis/api", { q: 'cihaz_list', where: { alan: 'adr.adr_Guid =', value: data, status: true } })
              .then(cihaz => {
                console.log(cihaz)
                this.cari=cihaz.data[0].unvan,
                this.gsm=cihaz.data[0].gsm,
                this.mail=cihaz.data[0].mail,
                this.adres=cihaz.data[0].adres,
                this.listCihaz = cihaz.data

                var index = cihaz.data.findIndex((word) => word.cihazid == cihazid);
                if (index != -1) {
                  this.lokasyon=cihaz.data[index].lokasyon;

                }
              })
          },
          changeCihaz(item) {
            Toast.loading({
            message: 'Bekleyiniz',
            forbidClick: true,
            loadingType: 'spinner',
          });  
            this.$request.post("servis/cihazdegistir/",{id:this.sid,cid:item.cihazid})
              .then(response => {
                console.log(response)
                if (response.status) {

                  this.$request.post("servis/cihazdegistirinfo/",{
                    id:this.sid,
                    serino:item.chz_serino,
                    barkod:item.barkod,
                    anagrup:item.cihazgrup,
                    altgrup:item.cihazaltgrup

                  })
                  .then(rsp => {
                    console.log(rsp)
                    if (rsp.status) { 

                      this.alias = item.cihazgrup+' '+item.cihazaltgrup;
                      this.cid = item.cihazid;
                      this.barkod = item.barkod;
                      this.serino = item.chz_serino;
                      this.lokasyon = item.lokasyon;

                  Toast('Cihaz Değiştirildi');
                  
                  this.show = false;
                    }

                  })               


                }
                else {

                }
             }).catch(err=>{
              console.log(err)
             })

          },
         
        getPostsAsync (){
          Toast.loading({
            message: 'Bekleyiniz',
            forbidClick: true,
            loadingType: 'spinner',
          });          
           this.$request.get("servis/detay/servis/"+this.ayar.ya+"/"+this.ayar.kid+"/"+this.id+"/"+this.table)
           .then(res => {
            console.log(res)
            this.getcihaz(res.servis[0].carid,res.servis[0].cid)

            this.$store.dispatch('aktifservis',res.servis[0])
            this.carid = res.servis[0].carid // adres guid
            this.sid = res.servis[0].sid;
            this.cid = res.servis[0].cid
            this.sdid =res.servis[0].sdid
            this.no =res.servis[0].no
            this.st = res.servis[0].st
            this.sd = res.servis[0].sd
            this.sn =res.servis[0].sn
            this.so = res.servis[0].so
            this.snot = res.servis[0].servis_notu
            this.barkod = res.servis[0].barkod
            this.serino = res.servis[0].serino
            this.alias = res.servis[0].anagrup+' '+res.servis[0].altgrup
            //this.model =res.servis[0].model
            this.cari = this.$helper.ilkharfBuyuk(res.servis[0].cari)
            // this.enlem = res.servis.enlem
            // this.boylam = res.servis.boylam
            this.adres=this.$helper.ilkharfBuyuk(res.servis[0].adres) 
            this.gsm=res.servis[0].gsm
            this.mail=res.servis[0].mail

            this.lokasyon = res.servis[0].lokasyon

           })
           .catch(err => {this.error.push(err)})
        },

           lokasyonUpdate(){
            Toast.loading({
              message: 'Bekleyiniz',
              forbidClick: true,
              loadingType: 'spinner',
            });
            var obje = {
            tablo:[{ No:94, KayitTipi: 1}],
            kayit:[ 
              { 
                chz_Guid:this.cid,
                chz_aciklama3:this.lokasyon,
              }
            ]

          }
          this.$request.post("servis/api/add", {obje:obje})
              .then(res => {
                console.log(res)
                Toast('Bilgiler Değiştirildi');
              })
           },
           cariUpdate(){
            Toast.loading({
              message: 'Bekleyiniz',
              forbidClick: true,
              loadingType: 'spinner',
            });
            var obje = {
            tablo:[{ No:32, KayitTipi: 1}],
            kayit:[ 
              { 
                adr_Guid:this.carid,
                adr_tel_faxno:this.mail,
                adr_tel_no1:this.gsm,
              }
            ]

          }
          console.log(obje.kayit[0])
          this.$request.post("servis/api/add", {obje:obje})
              .then(res => {
                if (res.status == "200") {
                  Toast('Bilgiler Değiştirildi');
                }
              })
           },           
baslat(){
Dialog.confirm({
  title: 'Servis Başlatılacak...',
  message: 'Onaylıyormusnuz ?',
})
  .then(() => {
                this.btspinner=true
                setTimeout(() => {
                    let islem = {
                      id:this.id, 
                      sd:3,
                      ptarih:new Date(),
                      psaat:this.$helper.trsaatyazdir(),
                      }
                      this.$request.post("servis/baslat/",islem)
                      .then(response => {
                        this.konum()
                        .then(res=> {
                          let log ={ 
                            servis_id : response.data.id,
                            tarih: response.data.ptarih,
                            saat :response.data.psaat,
                            sd:response.data.sd,
                            kid:this.ayar.kid,
                            islem: 'Servis Başlatıldı...',
                            enlem:res.lat,
                            boylam:res.long
                          }
                          this.$request.post("servis/servis_log/",log).then(() => {
                            this.sdid = 3
                            this.btspinner = false
                            Toast('Servis Başlatıldı');
                            })
                      })
                      })
}, 2000);
  })
  .catch(() => {
    Toast.loading({
      message: 'Bekleyiniz',
      forbidClick: true,
      loadingType: 'spinner',
    });
  });
},
        onChange(index) {
          this.activeName = index;
        },
    konum(){
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              resolve({
                  long:position.coords.longitude,
                  lat:position.coords.latitude
              })
            },
            // işlemleri kitlememek için reject göndermedik
            (error) => {
              resolve({
                  long:0,
                  lat:0
              })              
              //alert(error.message);
            }, {
                    enableHighAccuracy: true
                    , timeout: 5000
                }
            );
        } 
        // işlemleri kitlememek için reject göndermedik
        else { 
              resolve({
                  long:0,
                  lat:0
              })            
          //alert("Geolocation is not supported by this browser.");
             }
      })
    },        

}

};
</script>
<style scoped>
.van-popup .van-cell {
  font-size:12px !important
}
</style>


// WEBPACK FOOTER //
// src/components/servis/detay.vue